import React, { createContext, useContext, useState } from 'react';

const ServiceSelectedContext = createContext(undefined);

let setServiceSelectedGlobal = () => { };

export const ServiceSelectedProvider = ({ children }) => {
    const [serviceSelected, setServiceSelected] = useState('');

    setServiceSelectedGlobal = setServiceSelected;

    return (
        <ServiceSelectedContext.Provider value={{ serviceSelected, setServiceSelected }}>
            {children}
        </ServiceSelectedContext.Provider>
    );
};

export const useService = () => {
    const context = useContext(ServiceSelectedContext);
    if (!context) throw new Error('useService deve ser usado dentro de ServiceSelectedProvider');
    return context;
};

export const setGlobalService = (state) => {
    setServiceSelectedGlobal(state);
};
